import SectionHeading from '@/pages/home/components/SectionHeading';
import { usageTips } from '@/mocks/home';

export default function TipsSection() {
  return (
    <section id="tips" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="安全使用建议"
          title="如果一定要用，请守好这六条底线"
          desc="风险并不等于必然出事。把下面这些习惯固定下来，可以在享受便利的同时，把可能踩的坑降到最低。"
        />

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {usageTips.map((t) => (
            <div
              key={t.no}
              className="p-5 md:p-6 rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-center justify-between mb-4">
                <span className="font-heading font-black text-2xl text-primary-500">{t.no}</span>
                <span className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 border border-background-300 text-accent-600">
                  <i className="ri-shield-check-line"></i>
                </span>
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2">{t.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="md:col-span-2 p-5 rounded-lg bg-secondary-50 border border-secondary-200 flex items-start gap-3">
            <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
              <i className="ri-movie-2-line"></i>
            </span>
            <p className="text-sm text-foreground-700 leading-relaxed">
              <strong className="text-foreground-900 font-semibold">更稳妥的替代方案：</strong>
              如果只是为了偶尔看电影，正规影视平台、电视台官方客户端、公共图书馆的数字资源，都是内容更清晰、账号更安全的合规选择，长期使用反而更省心。
            </p>
          </div>
          <div className="p-5 rounded-lg bg-background-100 border border-background-200">
            <p className="text-xs text-foreground-500 mb-2">一句话提醒</p>
            <p className="text-sm text-foreground-800 leading-relaxed font-medium">
              便利可以有，底线不能破——不装、不授权、不付款。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}